/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { CSSProperties, Suspense } from "react";
import { Modal, Button } from "@clarkinc/zest-design-system";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import InfoIcon from "../infoicon.svg";
import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
import ShieldActive from "./shieldactive.svg";
import ShieldInactive from "./shieldinactive.svg";
import { ExtendedWarranty } from "~/ProductDetails/ProductDetailPageResult";
import(/* webpackChunkName: "YourInformationSectionToolTip" */"../tippy.css");
const Tippy = React.lazy(() => import("@tippyjs/react"));
interface Props {
  hasSelectedGroupMember: boolean;
  handleAddProtection: (event: React.SyntheticEvent) => void;
  handleRemoveProtection: (event: React.SyntheticEvent) => void;
  product: PricingProduct;
  selectedWarranty?: ExtendedWarranty;
  warrantyInfo: string;
}
const ExtendedWarrantyComponent = ({
  hasSelectedGroupMember,
  handleAddProtection,
  handleRemoveProtection,
  product,
  selectedWarranty,
  warrantyInfo
}: Props) => {
  const {
    extendedWarranties
  } = product;
  const extendedWarranty = extendedWarranties[0];
  const extendedWarrantyPrice = extendedWarranty?.price ?? 0;
  const buttonEnabledStyle: CSSProperties = {
    width: "110px",
    cursor: "pointer"
  };
  const buttonEnabledCSSClass = "bg-origin-box-border bg-repeat-x border-solid border box-border cursor-pointer inline-block font-semibold text-center no-underline hover:no-underline antialiased hover:bg-position-y-15 flex-shrink-0 ml-auto rounded text-xs leading-3 py-1 px-2 bg-green-500 bg-green-500 hover:bg-green-800 border-none text-white hover:text-white align-middle";
  const removeProtection = (e: React.SyntheticEvent) => {
    handleRemoveProtection(e);
    document.getElementById("addProtectionButton")?.focus();
  };
  return <>
      <div className="
              bg-white
              border-gray-500
              rounded
              box-border
              flex
              items-center
              flex-1
              mx-auto
              mb-2 py-3 w-full" id="whatWeOfferExtendedWarranty">
        <span className="flex-shrink-0 h-10 w-10" id="extendedWarrantyShieldIconInactive" hidden={!!selectedWarranty}>
          <img alt="shield icon" className="h-10 w-10" src={ShieldInactive} />
        </span>
        <span className="flex-shrink-0 h-10 w-10" id="extendedWarrantyShieldIconActive" hidden={!selectedWarranty}>
          <img alt="shield icon" className="h-10 w-10" src={ShieldActive} />
        </span>
        <div className="px-2">
          <h4 className="leading-3 mb-1" data-testid="proetct-your-product">
            Protect Your Product
          </h4>
          <p className="
                  font-normal
                  text-xs
                  leading-none
                  mb-0
                  text-left
                  text-gray-800" id="extendedWarrantyInfoTextInactive" data-testid="extendedWarranty-InfoText-Inactive">
            {"Coverage starting at "}
            <span id="coverageStartingAtPrice">
              {formatAsCurrency.formatIfUndefined(extendedWarrantyPrice)}
            </span>
            &nbsp;
            <Suspense fallback={null} data-sentry-element="Suspense" data-sentry-source-file="ExtendedWarrantyComponent.tsx">
              <Tippy content={warrantyInfo} data-sentry-element="Tippy" data-sentry-source-file="ExtendedWarrantyComponent.tsx">
                <img alt="info icon" className="h-4 w-4" src={InfoIcon} data-testid="popover-icon" />
              </Tippy>
            </Suspense>
          </p>
          <p className="
                      font-normal
                      text-xs
                      leading-none
                      mb-0
                      text-left
                      text-gray-800" id="extendedWarrantyInfoTextActive" data-testid="extendedWarranty-InfoText-Active" hidden={!selectedWarranty}>
            <span id="extendedWarrantyInfoTextSelectedTermName">
              {selectedWarranty?.name}
              {selectedWarranty?.name?.charAt(0) !== "1" ? "s" : ""}
            </span>
            &nbsp;
            <Modal.Trigger type="button" id="extendedWarrantyInfoTextEditWarranty" className="text-green-500 underline" data-testid="warranty-edit" htmlFor="extended-warranty-modal-dialog" data-sentry-element="unknown" data-sentry-source-file="ExtendedWarrantyComponent.tsx">
              Edit
            </Modal.Trigger>
            &nbsp;&nbsp;
            <Button type="button" id="extendedWarrantyInfoTextRemoveWarranty" className="underline text-green-500 bg-white" onClick={removeProtection} data-testid="warranty-remove" theme="headless" data-sentry-element="Button" data-sentry-source-file="ExtendedWarrantyComponent.tsx">
              Remove
            </Button>
          </p>
        </div>
        {!selectedWarranty && <Modal.Trigger onClick={handleAddProtection} className={buttonEnabledCSSClass} style={buttonEnabledStyle} htmlFor="extended-warranty-modal-dialog" type={hasSelectedGroupMember ? "submit" : "button"} id="addProtectionButton">
            Add Protection
          </Modal.Trigger>}
      </div>
    </>;
};
export default ExtendedWarrantyComponent;